import type { RouteLocationRaw } from 'vue-router'

// What clicking the card does: follow a route, or open a modal over the chat
type WidgetResource =
  | { icon: string; route: (id: string | number) => RouteLocationRaw }
  | { icon: string; modal: 'mail_draft' }

export const WIDGET_RESOURCES: Record<string, WidgetResource> = {
  dossier: {
    icon: 'folder',
    route: (id) => ({ name: 'dossier_form_edit_route', params: { id } })
  },
  item: {
    icon: 'boxes-stacked',
    route: (id) => ({ name: 'item_view_route', params: { id: id } })
  },
  wiki_place: {
    icon: 'map-marker-alt',
    route: (id) => ({ name: 'route_place_id', params: { placeId: id } })
  },
  wiki_city: {
    icon: 'city',
    route: (id) => ({
      name: 'wiki_city_municipal_administration_index_page_route',
      params: { city_id: id }
    })
  },
  // A table the assistant built from a reporting recipe, opened full width
  report: {
    icon: 'table',
    route: (id) => ({ name: 'report_page_route', params: { id } })
  },
  // A draft email the assistant wrote, reviewed and sent from the composer
  model_notification: {
    icon: 'envelope',
    modal: 'mail_draft'
  }
}

export function isKnownWidgetResource(resourceType: unknown): boolean {
  return (
    typeof resourceType === 'string' &&
    Object.prototype.hasOwnProperty.call(WIDGET_RESOURCES, resourceType)
  )
}

export function widgetRoute(
  resourceType: string,
  resourceId: string | number
): RouteLocationRaw | null {
  const resource = WIDGET_RESOURCES[resourceType]
  return resource && 'route' in resource ? resource.route(resourceId) : null
}

export function widgetModal(resourceType: string): 'mail_draft' | null {
  const resource = WIDGET_RESOURCES[resourceType]
  return resource && 'modal' in resource ? resource.modal : null
}
